import { useAuth } from "@/contexts/AuthContext";
import { useLocation } from "react-router-dom";

export function useBottomNavigation() {
  const { user, userRole } = useAuth();
  const location = useLocation();

  const isActiveRoute = (path: string) => {
    if (path === "/") return location.pathname === "/";
    if (path.includes("/dashboard") && location.pathname.includes("/dashboard"))
      return true;

    // Exact match for specific routes to avoid conflicts
    if (path === "/profiles") return location.pathname === "/profiles";
    if (path === "/profile") return location.pathname === "/profile";
    if (path === "/charts") return location.pathname === "/charts";

    return location.pathname.startsWith(path);
  };

  const shouldShowBottomNav = () => {
    // Hide bottom nav on certain pages where it might interfere
    const hideOnPages = [
      "/login",
      "/register",
      "/forgot-password",
      "/reset-password",
    ];

    return !hideOnPages.some((page) => location.pathname.startsWith(page));
  };

  return {
    user,
    userRole,
    location,
    isActiveRoute,
    shouldShowBottomNav: shouldShowBottomNav(),
  };
}
